import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {signup} from '../auth';


class Signup extends Component {
    constructor() {
        super();
        this.state = {
            name: "",
            email: "",
            password: "",
            error: "",
            open: false
        }
    }

    handleChange = (name) => event => {
        this.setState({ error: "" });
        this.setState({ [name]: event.target.value });
    }

    clickSubmit = event => {
        event.preventDefault();
        const { name, email, password } = this.state;

        const user = {
            name, email, password
        };
        //console.log(user);
        signup(user)
            .then(data => {
                if (data.error) {
                    this.setState({ error: data.error });
                } else {
                    this.setState({ name: "", email: "", password: "", error: "", open: true });
                }
            })
    }

    
    signupForm = (name, email, password) => (

        <form>
            <div className="form-group">
                <label className="text-muted">Name</label>
                <input onChange={this.handleChange("name")} type="text" className="form-control" value={name} />
            </div>
            <div className="form-group">
                <label className="text-muted">Email Address</label>
                <input onChange={this.handleChange("email")} type="email" className="form-control" value={email} />
            </div>
            <div className="form-group">
                <label className="text-muted">Password</label>
                <input onChange={this.handleChange("password")} type="password" className="form-control" value={password} />
            </div>
            <button onClick={this.clickSubmit} className="btn btn-raised btn-primary">Submit</button>
        </form>
    )

    render() {
        const { name, email, password, error, open } = this.state;
        return (
            <div className="container">
                <h2 className="mt-5">Signup</h2>
                {this.signupForm(name, email, password)}
                <div className="alert alert-danger" style={{ visibility: error ? "visible" : "hidden" }}>
                    {error}
                </div>
                <div className="alert alert-info" style={{ visibility: open ? "visible" : "hidden" }}>
                    New account has been created. <Link to="/signin">Please Signin</Link>.
                </div>
            </div>
        );
    }
}

export default Signup;